
import { inject, Injectable, DOCUMENT } from "@angular/core";

@Injectable({ providedIn: "root" })
export class CanonicalUrlService {
  private readonly document = inject(DOCUMENT);
  private readonly baseUrl = "https://www.retrodigital.sg.ch/";

  private ensureTag(): HTMLLinkElement {
    const canonicalLink = this.document.querySelector<HTMLLinkElement>('link[rel="canonical"]');
    if (canonicalLink) {
      return canonicalLink;
    } else {
      const canonicalLink = this.document.createElement("link") as HTMLLinkElement;
      const head = this.document.querySelector("head")!;
      canonicalLink.setAttribute("rel", "canonical");
      canonicalLink.setAttribute("href", this.baseUrl);
      head.appendChild(canonicalLink);
      return canonicalLink;
    }
  }

  /** Resolves a path against the canonical origin, dropping any query string and fragment. */
  toAbsolute(relativeUrl: string | null): string {
    const urlObj = new URL(relativeUrl ?? "", this.baseUrl);
    return `${urlObj.origin}${urlObj.pathname}`;
  }

  updateTag(relativeUrl: string | null) {
    this.ensureTag().setAttribute("href", this.toAbsolute(relativeUrl));
  }
}
